export const walkthroughStoreKey = 'traning_is_finish';
